<div mat-dialog-content class="app-signout-confirmation" id="app-signout-confirmation" [style.background-color]="settingsData?.event_bg_main_color +'!important'" [style.color]="settingsData?.event_font_main_color +'!important'">
    <div class="fs-16 pt-20 pb-10 text-center fw-500">Ticket already purchased. Do you want to purchase?</div>
    <div class="pb-20 text-center" mat-dialog-actions>
        <button mat-flat-button (click)="continue('yes')" class="flat-primary-button primary-bg-button mt-10"
        [style.background-color]="settingsData?.event_button_bg_primary_color +'!important'" [style.color]="settingsData?.event_button_font_primary_color +'!important'">
            yes
        </button>
        <button mat-flat-button (click)="continue('no')" class="flat-primary-button secondary-bg-btn1 secondary-button-color mt-10"
        [style.background-color]="settingsData?.event_button_bg_secondary_color +'!important'" [style.color]="settingsData?.event_button_font_secondary_color +'!important'">
            No
        </button>
    </div>
</div>
